import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  actionRequestCountries,
  actionRequestCurrencies,
  actionRequestLegalEntities,
  actionRequestLocales,
} from '../../redux/actions/SessionData';

const useInitialization = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actionRequestCountries());
    dispatch(actionRequestLocales());
    dispatch(actionRequestLegalEntities());
    dispatch(actionRequestCurrencies());
  }, [dispatch]);
};

export default useInitialization;
